import styled, { css } from 'styled-components';

import { AspectRatioImage } from '@/components/AspectRatioImage/AspectRatioImage';
import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { Select } from '@/components/Select';

export const TopBannerWrapper = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    // overflow: hidden;
    height: 320px;
    ${theme.media.md.up} {
      height: 340px;
    }
  `};
`;
export const BreadCrumbSection = styled(Box)`
  ${({ theme }) => css`
    padding-top: 0;
    position: relative;
    z-index: 3;
    ${theme.media.md.up} {
      padding-top: 5px;
    }
  `};
`;

export const BreadCrumbContent = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    ${theme.media.md.up} {
      padding-top: 10px;
    }
  `};
`;
export const StyledContainer = styled(Container)`
  height: 100%;
  z-index: 3;
`;
export const TextWrapper = styled(Flex)`
  align-items: center;
  position: relative;
  height: 100%;
  width: 100%;
`;
export const TextContainer = styled(Box)`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
    min-width: 100%;
    ${theme.media.md.up} {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      min-width: 100%;
      flex-direction: row;
      justify-content: space-between;
    }
  `};
`;
export const ImageWrapper = styled(Box)`
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
`;

export const StyledImage = styled(NextImage)`
  max-width: 100%;
  object-fit: cover;
  height: 100%;
  width: 100%;
`;
export const Mask = styled(Box)`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.4);
  left: 0;
  top: 0;
`;
export const StyledSelect = styled(Select)`
  ${({ theme }) => css`
    & > div {
      width: 320px;
    }
    ${theme.media.md.up} {
      & > div {
        width: 240px;
      }
    }
  `};
`;
export const BoutiquesContent = styled(Box)`
  margin-right: auto;
  margin-left: auto;
`;
export const BoutiqueListFlex = styled(Box)`
  ${({ theme }) => css`
    padding-top: 15px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 0 1 auto;
    margin-left: -8px;
    margin-right: -8px;
    ${theme.media.md.up} {
      padding-top: 30px;
    }
  `};
`;
export const StyledHeading = styled.h1`
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    margin: 0.67em 0;
    line-height: 1;
    letter-spacing: 0;
    margin-bottom: 0;
    margin-top: 0;
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    padding-bottom: 10px;
    color: ${theme.colors.white};
    ${theme.media.md.up} {
      font-family: ${theme.fontFamilies.italianPlate};
      font-size: 50px;
      max-width: 45%;
      min-width: 45%;
      text-align: left;
    }
  `};
`;
export const StyledAspectRatioImage = styled(AspectRatioImage)`
  object-fit: cover;
  height: 100%;
`;
export const NotFoundStores = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(4)};
    margin-bottom: ${theme.spacing(4)};
    gap: ${theme.spacing(1)};
  `};
`;
export const TextBox = styled(Box)`
  text-align: center;
`;
export const StoreLocator = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 1rem;
  a {
    text-decoration: none;
  }
`;
